export default __webpack_public_path__ + "static/media/laconic_main_mobile.f0dde8cf.jpg";